import forEach from '../../../../javascripts/dom/forEach';

const contactFinders = document.querySelectorAll('[data-js-module="o-contact-finder"]');

const init = async () => {
  const { default: ContactFinder } = await import(
    /* webpackChunkName: "o-contact-finder" */ './contact-finder'
  );
  forEach(contactFinders, (index, element) => new ContactFinder(element));
};

if (contactFinders.length) init();
